import React from 'react'

export const H1 = (props) => (<h1 style={{ textAlign: props.align }}>{props.children}</h1>)
export const H2 = (props) => (<h2 style={{ textAlign: props.align }}>{props.children}</h2>)
export const H3 = (props) => (<h3 style={{ textAlign: props.align }}>{props.children}</h3>)
export const H4 = (props) => (<h4 style={{ textAlign: props.align }}>{props.children}</h4>)
export const H5 = (props) => (<h5 style={{ textAlign: props.align }}>{props.children}</h5>)
export const H6 = (props) => (<h6 style={{ textAlign: props.align }}>{props.children}</h6>)
